// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__dX-L7","content":"Loading_content__LZ4RE","animated":"Loading_animated__QhmcM","rotation":"Loading_rotation__BhLSQ","logo":"Loading_logo__ax6om"};